import React from 'react';
import { connect } from 'react-redux';
import { HttpStateLine } from 'state-line';

import Dialog from 'xgimi-ui/Dialog';
import Form from 'xgimi-ui/Form';
import InfoSelect from 'xgimi-ui/Info/Select';
import Button from 'xgimi-ui/Button';

import StoreComponent, { mapStateToProps } from '../../../../../appComponents/Store';

import s from './.module.scss';
import Api from '../../../../../api';

interface Props {
  // 是否打开
  isOpen: boolean;
  // 数据
  data: Record<string, any>;
  // 关闭
  onClose: () => void;
  // 保存成功
  onSuccess: () => void;

}

interface State {
}

/**
 * 指派
 */
class Component extends StoreComponent<Props, State> {
  // 负责人
  private assignData: string = '';

  /**
   * 确认
   */
  private onConfirm = (): void => {
    // 没有选负责人时
    if (!this.assignData) {
      this.storeState.common.toast.current?.show({ content: '请先填写负责人' });
      return;
    }
    this.assign();
  };

  /**
   * 指派
   */
  private assign = (): void => {
    const name = this.assignData.split('=') || [];
    new HttpStateLine(new Api.crmFeedback.AssignFeedback({
      feedbackNo: this.props.data.feedbackNo,
      ownerUser: name[0],
      ownerUserName: name[1],
    }), {
      onSuccess: () => {
        this.props.onSuccess();
         this.storeState.common.toast.current?.show({ content: '指派成功' });
      },
      onFail: (httpStateLine) => {
        this.storeState.common.toast.current?.show({ content: httpStateLine.result?.message });
      },
    }).run();
  };

  render(): React.ReactNode {
    return (
      <Dialog
        className={s.dialog}
        isOpen={this.props.isOpen}
        onClose={this.props.onClose}
        isResponsive={true}
        isAutoClose={true}
      >
        <div className={s.container}>
          <div className={s.actionButton}>
            <Button size="large" variant="text" color="primary" onClick={this.props.onClose}>取消</Button>
            <Button size="large" variant="text" color="primary" onClick={this.onConfirm}>确定</Button>
          </div>
          <Form className={s.form}>
            <InfoSelect
              classes={{ root: s.select }}
              placeholder={'请输入中文名搜索'}
              isUpdate={true}
              variant={'outlined'}
              getOptions={(data) => new Promise((resolve): void => {
                // 有数据时才搜索
                if (data) {
                  new HttpStateLine(new Api.crmFeedback.GetNameList({ cn_name: data })).run()
                    .then((httpStateLine) => {
                      resolve(httpStateLine.result.data.list.map((item: Record<string, any>) => ({
                        label: `${item.cn_name}(${item.user_name})`,
                        value: `${item.user_name}=${item.cn_name}`,
                      })));
                    });
                } else {
                  resolve([]);
                }
              })}
              onUpdate={(data) => {
                this.assignData = data;
              }}
            />
          </Form>
        </div>
      </Dialog>
    );
  }
}
export default connect(mapStateToProps)(Component);
